import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IDS } from "../../utils/IDS";
import { GET, POST } from "../../utils/Methods";
import { APIS } from "../../utils/APIS";
import Cookies from "js-cookie";

// Auth - Login
export const SendOtpEmail = createAsyncThunk(
  "common/send-otp/email",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Common?.send_otp_email, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const VerifyOtpEmail = createAsyncThunk(
  "common/verify-otp/email",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Common?.verify_otp_email, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const ForgetPasswordEmail = createAsyncThunk(
  "common/forget-password/email",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Common?.forget_password, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const Slice = createSlice({
  name: "common",
  initialState: {
    data: {},
    token: null,
    role: null,
    permissions: null,
    isLogin: false,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {
    // Add any additional reducers if needed
  },
  extraReducers: (builder) => {
    builder
      .addCase(SendOtpEmail.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(SendOtpEmail.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.token = action.payload.data.token;
        state.role = action.payload.data.role;
        state.permissions = action.payload.data.permissions;
        state.isLogin = true;
      })
      .addCase(SendOtpEmail.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        state.isLogin = false;
      })

      .addCase(VerifyOtpEmail.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(VerifyOtpEmail.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.token = action.payload.data.token;
        state.role = action.payload.data.role;
        state.permissions = action.payload.data.permissions;
        state.isLogin = true;
      })
      .addCase(VerifyOtpEmail.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        state.isLogin = false;
      })

      .addCase(ForgetPasswordEmail.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(ForgetPasswordEmail.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.token = action.payload.data.token;
        state.role = action.payload.data.role;
        state.permissions = action.payload.data.permissions;
        state.isLogin = true;
      })
      .addCase(ForgetPasswordEmail.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        state.isLogin = false;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
